import { type ComponentProps, memo } from 'react';

export type AssetModalLeftPanelContentProps = Pick<ComponentProps<'div'>, 'children'>;

export const AssetModalLeftPanelContent = memo(({ children }: AssetModalLeftPanelContentProps) => {
  return <div className="relative h-full min-h-0">{children}</div>;
});

AssetModalLeftPanelContent.displayName = 'AssetModalLeftPanelContent';
